<template slot="social">
  <div
    class="social-share-bar"
    :class="getVariant('social-share-bar')"
  >
    <p>{{ $t('share_text') }}</p>
    <button-twitter
      :article="article"
    />
    <button-linkedin
      :article="article"
    />
    <button-facebook
      :article="article"
    />
  </div>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'SocialShareBar',

  components: {
    ButtonTwitter: () => import('@/components/share/button-twitter'),
    ButtonLinkedin: () => import('@/components/share/button-linkedin'),
    ButtonFacebook: () => import('@/components/share/button-facebook')
  },

  mixins: [variant],

  props: {
    article: {
      type: Object,
      required: true,
      default: null
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/share/social-share-bar.scss"></style>



// WEBPACK FOOTER //
// social-share-bar.vue